import { CustomCellRendererProps } from 'ag-grid-react';

import CellRendererForAgGrid from './CellRendererForAgGrid';

export const LeafRowCellRenderer = (props: CustomCellRendererProps) => {
  if (props.node?.group) {
    return null;
  }

  return <CellRendererForAgGrid {...props} />;
};
